import { ConfigStateService } from '@abp/ng.core';
import { RoleConstants } from '../constants/role.constant';
import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class RoleHelper {
  constructor(private config: ConfigStateService) {}

  isSuperAdminUser(): boolean {
    let roles = this.config.getDeep('currentUser.roles');
    return roles.includes(RoleConstants.admin);
  }

  isHostAdmin(): boolean {
    const currentUser = this.config.getDeep('currentUser');
    const impersonatorUserId = currentUser?.impersonatorUserId ?? null;

    if (impersonatorUserId != null) {
      // Impersonation active: the real impersonator's tenant is null => host-side.
      return (currentUser?.impersonatorTenantId ?? null) == null;
    }

    // No impersonation: user's own home tenant must be null AND have the "admin" role.
    const roles: string[] = currentUser?.roles ?? [];
    return (currentUser?.tenantId ?? null) == null && roles.includes(RoleConstants.admin);
  }

  isTenantAdminUser(): boolean {
    let roles = this.config.getDeep('currentUser.roles');
    return roles.includes(RoleConstants.tenantAdmin);
  }
}
